import { useMemo, useState } from "react";
import { Box, Container, InputBase } from "@mui/material";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { useNavigate } from "react-router-dom";
import type { GridPaginationModel, GridRowParams } from "@mui/x-data-grid";
import { youtubeChannelsMock } from "./mockData";
import { YouTubeChannel } from "./youtubechannel.types";
import YouTubeChannelDataGrid from "./components/YoutubeChannelDataGrid";

export default function YouTubeChannelListPage() {
  const navigate = useNavigate();

  const [search, setSearch] = useState("");
  const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({
    page: 0,
    pageSize: 10,
  });

  const filteredRows = useMemo(() => {
    const term = search.toLowerCase().trim();

    if (!term) return youtubeChannelsMock;

    return youtubeChannelsMock.filter((channel) => {
      return (
        channel.name.toLowerCase().includes(term) ||
        channel.display_name?.toLowerCase().includes(term) ||
        channel.company.name.toLowerCase().includes(term)
      );
    });
  }, [search]);

  const handleView = (channel: YouTubeChannel) => {
    navigate(`/youtube-channels/${channel.id}`);
  };

  const handleReauthenticate = (channel: YouTubeChannel) => {
    console.log("Re-authenticate:", channel);
    // window.location.href = channel.reauth_url || "";
  };

  const handleRowClick = (params: GridRowParams<YouTubeChannel>) => {
    navigate(`/youtube-channels/${params.row.id}`);
  };

  return (
    <Container maxWidth="xl">
      <Box
        sx={{
          mb: 3,
          width: { xs: "100%", md: "35%" },
          display: "flex",
          alignItems: "center",
          backgroundColor: "background.paper",
          borderRadius: 2,
          px: 1.5,
          py: 0.5,
        }}
      >
        <SearchOutlinedIcon sx={{ color: "text.primary", mr: 1 }} />
        <InputBase
          fullWidth
          placeholder="Search by youtube channel name..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          sx={{ color: "text.primary" }}
        />
      </Box>

      <YouTubeChannelDataGrid
        rows={filteredRows}
        rowCount={filteredRows.length}
        loading={false}
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
        onView={handleView}
        onReauthenticate={handleReauthenticate}
        onRowClick={handleRowClick}
      />
    </Container>
  );
}
